module.exports = __WEBPACK_EXTERNAL_MODULE_9__;


//////////////////
// WEBPACK FOOTER
// external {"root":["ng","core"],"commonjs":"@angular/core","commonjs2":"@angular/core","amd":"@angular/core"}
// module id = 9
// module chunks = 0 1